import React, { type FC, useMemo } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Unauthorized from "src/components/Pages/Unauthorized/Unauthorized";
import CountryDisabled from "src/components/Pages/Disabled/Disabled";
import { renewMidwayTokenOrRedirect } from "src/midway/MidwayConnector";
import { isPayeeCentral, isStandalone } from "../api/config";
import InboundDocument from "./Pages/DocumentInbound";
import DocumentListing from "./Pages/DocumentList";
import { documentListingLoader } from "./Pages/DocumentList/loader";
import Nest from "./Pages/Nest";
import PageNotFound from "./Pages/NotFound/PageNotFound";
import { setPayeeIntegrationCookie } from "src/cookies";
import {
  DisabledPagePath,
  DocumentListingInboundCentralPath,
  DocumentListingIndexExternalPath,
  DocumentListingIndexInternalPath,
  DocumentListingRootPath,
  InboundDocumentPath,
  InboundDocumentPathWithInboundDocumentTab,
  NestPath,
  UnauthorizedPagePath,
} from "./routes";

const router = createBrowserRouter([
  { path: NestPath, element: <Nest />, loader: documentListingLoader },
  {
    path: DocumentListingRootPath,
    element: <DocumentListing />,
    loader: documentListingLoader,
  },
  {
    path: DocumentListingIndexExternalPath,
    element: <DocumentListing />,
    loader: documentListingLoader,
  },
  {
    path: DocumentListingIndexInternalPath,
    element: <DocumentListing />,
    loader: documentListingLoader,
  },
  { path: InboundDocumentPath, element: <InboundDocument /> },
  {
    path: InboundDocumentPathWithInboundDocumentTab,
    element: <InboundDocument />,
  },
  {
    path: DocumentListingInboundCentralPath,
    element: <DocumentListing />,
    loader: documentListingLoader,
  },
  { path: UnauthorizedPagePath, element: <Unauthorized /> },
  { path: DisabledPagePath, element: <CountryDisabled /> },
  { path: "*", element: <PageNotFound /> },
]);

export const App: FC = () => {
  useMemo(() => {
    if (isPayeeCentral()) {
      setPayeeIntegrationCookie();
    } else if (isStandalone()) {
      renewMidwayTokenOrRedirect();
    }
  }, []);

  return <RouterProvider router={router} />;
};
